import { render, staticRenderFns } from "./EmailSVG.vue?vue&type=template&id=05a57f70&"
import script from "./EmailSVG.vue?vue&type=script&lang=js&"
export * from "./EmailSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports